import React from 'react';
import { FormattedDate } from 'react-intl';

export interface INullableFormattedDateProps {
    value?: Date | string | null | undefined;
}

export class NullableFormattedDate extends React.Component<INullableFormattedDateProps, Record<string, unknown>> {
    public override render() {
        if (!this.props.value) {
            return null;
        }
        return <FormattedDate value={this.props.value} year="numeric" month="short" day="numeric" />;
    }
}
